import { t } from '@/utility/localization';

export default () => {
  const activityTypes = {
    ACTIVITY_SUBSCRIPTION_JOINED: 'activity-subscription-joined',
    ACTIVITY_SUBSCRIPTION_PENDING_APPROVAL:
      'activity-subscription-pending-approval',
    ACTIVITY_SUBSCRIPTION_UNSUBSCRIBED:
      'activity-subscription-unsubscribed',
    ACTIVITY_EVENT_REGISTERED: 'activity-event-registered',
    ACTIVITY_SESSION_BOOKED: 'activity-session-booked',
    ACTIVITY_FOLDER_PURCHASED: 'activity-folder-purchased',
    ACTIVITY_MILESTONE_COMMUNITY_CREATED:
      'activity-milestone-community-created',
    ACTIVITY_MILESTONE_FIRST_SALE: 'activity-milestone-first-sale',
    ACTIVITY_MILESTONE_FIRST_EVENT: 'activity-milestone-first-event',
    ACTIVITY_MILESTONE_FIRST_CONTENT: 'activity-milestone-first-content',
    ACTIVITY_MILESTONE_FIRST_POST: 'activity-milestone-first-post',
    ACTIVITY_MILESTONE_ONE_DOLLAR_GIFT:
      'activity-milestone-one-dollar-gift-jan-2024',
    ACTIVITY_MILESTONE_FIVE_DOLLAR_GIFT:
      'activity-milestone-five-dollar-gift-feb-2024',
    ACTIVITY_MILESTONE_FIRST_SESSION: 'activity-milestone-first-session'
  };

  const filterOptions = [
    {
      label: t('all'),
      value: ''
    },
    {
      label: t('new-members'),
      value: activityTypes.ACTIVITY_SUBSCRIPTION_JOINED
    },
    {
      label: t('register-for-event'),
      value: activityTypes.ACTIVITY_EVENT_REGISTERED
    },
    {
      label: t('booked-a-session'),
      value: activityTypes.ACTIVITY_SESSION_BOOKED
    },
    {
      label: t('purchase-product'),
      value: activityTypes.ACTIVITY_FOLDER_PURCHASED
    },
    {
      label: t('pending-approval'),
      value: activityTypes.ACTIVITY_SUBSCRIPTION_PENDING_APPROVAL
    },
    {
      label: t('unsubscribed'),
      value: activityTypes.ACTIVITY_SUBSCRIPTION_UNSUBSCRIBED
    },
    {
      label: t('milestones'),
      value: `${activityTypes.ACTIVITY_MILESTONE_COMMUNITY_CREATED},${activityTypes.ACTIVITY_MILESTONE_FIRST_CONTENT},${activityTypes.ACTIVITY_MILESTONE_FIRST_EVENT},${activityTypes.ACTIVITY_MILESTONE_FIRST_POST},${activityTypes.ACTIVITY_MILESTONE_FIRST_SALE},${activityTypes.ACTIVITY_MILESTONE_ONE_DOLLAR_GIFT},${activityTypes.ACTIVITY_MILESTONE_FIVE_DOLLAR_GIFT},${activityTypes.ACTIVITY_MILESTONE_FIRST_SESSION}`
    }
  ];

  const milestoneKey = 'activity-milestone';

  const linkTypes = {
    MEMBER: 'MEMBER',
    EVENT: 'EVENT',
    FOLDER: 'FOLDER',
    SESSION: 'SESSION',
    CHALLENGE: 'CHALLENGE'
  };

  return { linkTypes, filterOptions, milestoneKey, activityTypes };
};
